import { TrialCancelledCompanyListPage } from "@/features/company/pages/TrialCancelledCompanyList";
import React from "react";

const TrialCancelledCompanyList = () => {
  return <TrialCancelledCompanyListPage />;
};

export default TrialCancelledCompanyList;
